import { useEffect } from "react";
import { FacilityTypesList } from "../list/list";
import { logEvent } from "@shared/analytics/analytics";

export default function Landing() {
  useEffect(() => {
    logEvent("facility_types_landing_viewed");
  }, []);
  return (
    <div className="p-2 space-y-6">
      <div>
        <p className="page-title">Facility Types</p>
        <p className="page-subtitle">
          Manage facility types and their descriptions for your water utility
          system.
        </p>
      </div>
      <FacilityTypesList />
    </div>
  );
}
